import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
export interface GridColumn { key: string; label: string; }
export type GridRow = Record<string, unknown> & { id: string; name: string };
export interface GridAction { key: string; label: string; onlyWhen?: string; }
@Component({selector:'sr-admin-data-table',standalone:true,imports:[FormsModule],templateUrl:'./admin-data-table.component.html',styleUrl:'./admin-data-table.component.css'})
export class AdminDataTableComponent {
  @Input() rows: GridRow[] = [];
  @Input() columns: GridColumn[] = [];
  @Input() actions: GridAction[] = [];
  @Input() selection: string[] | null = null;
  @Input() readOnly = false;
  @Input() label = 'Registros';
  @Output() readonly action = new EventEmitter<{key:string; row:GridRow}>();
  @Output() readonly selectionChange = new EventEmitter<string[]>();
  filters: Record<string,string> = {};
  sortKey = 'name'; direction: 'asc' | 'desc' = 'asc'; page = 1; pageSize = 10;
  private value(row:GridRow,key:string):string { return key==='$assigned' ? this.selection?.includes(row.id)?'Sí':'No' : String(row[key] ?? ''); }
  get filtered(): GridRow[] {
    return this.rows.filter(row => this.columns.every(c => String(row[c.key] ?? '').toLocaleLowerCase('es').includes((this.filters[c.key] ?? '').trim().toLocaleLowerCase('es'))))
      .filter(row=>this.selection===null || !this.filters['$assigned'] || this.value(row,'$assigned')===this.filters['$assigned'])
      .sort((a,b) => this.value(a,this.sortKey).localeCompare(this.value(b,this.sortKey),'es',{numeric:true}) * (this.direction==='asc'?1:-1));
  }
  get pages(): number { return Math.max(1,Math.ceil(this.filtered.length/this.pageSize)); }
  get currentPage(): number { return Math.min(this.page,this.pages); }
  get visible(): GridRow[] { return this.filtered.slice((this.currentPage-1)*this.pageSize,this.currentPage*this.pageSize); }
  sort(key: string): void { this.direction = this.sortKey===key && this.direction==='asc'?'desc':'asc'; this.sortKey=key; this.page=1; }
  choose(id: string, checked: boolean): void { this.selectionChange.emit(checked?[...new Set([...(this.selection ?? []),id])]:(this.selection ?? []).filter(value=>value!==id)); }
}
